import { useState } from "react";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import { dataValidator } from "../../tools/dataValidator";

import { getLabel } from "../../tools/Dictionary";

/*
Used by : ProcessDesignerToolbar
*/

const ProcessDesignerDetailSetting = (props) =>
{

  //Props
  const Step = props.Step;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const OnCloseModal = props.OnCloseModal;
  const OnEditStep = props.OnEditStep;
  const OnDeleteStep = props.OnDeleteStep;
  const OnClickHome = props.OnClickHome;

  //State
  const [form, setForm] = useState({

  });
  const [error, setError] = useState({

  });
  const [loading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Variable
  const listNavigation = [
    "Next",
    "Home",
    "Back"
  ]

  useMount(() =>
  {
    loadData();
  }, []);

  const loadData = () =>
  {

    setForm(Step);

  };


  const onChangeTitle = (e) => {

    let title = e.target.value;

    if (title.length > 60) return; //Check length

    onValidateField("title", title); //Validate field value

    setForm(form => ({
      ...form,
      title
    }));
  }

  const onChangeNavigation = (e) => {

    let navigationButton = e.target.value;


    setForm(form => ({
      ...form,
      navigationButton
    }));

  };

  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "title";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:60"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };

  const onClickConfirm = () => {

    try{

      if (!onValidateField()) throw new Error(getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."));

      OnEditStep(form);

      OnCloseModal();

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      })

    };

 

    
  };

  const onClickDelete = () =>
  {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("App", "Are you sure you want to delete this entity?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onDelete,
      Display: true
    }));

  };

  const onDelete = async () =>
  {

    try
    {

      setConfirm(confirm => ({ ...confirm, Display: false }));


      await OnDeleteStep(Step._id);

      OnClickHome();

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    };

  }


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessDesigner", "Settings")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessDesigner", "Step title")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["title"] ? "page_modal_body_col_input_error" : "")}
                value={form.title || ""}
                onChange={onChangeTitle}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading || ReadOnly}
              />
              {error["title"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["title"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessDesignerDetail", "Navigation")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <select
                className="page_select_input "
                value={form.navigationButton}
                onChange={onChangeNavigation}
                disabled={!Access.canWrite || loading || ReadOnly}
              >
                {listNavigation.map((o, index) => (
                  <option key={index} value={o} >
                    {getLabel("ProcessDesignerDetail", o)}
                  </option>
                ))}
              </select>
            </div>
          </div>
          
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {(Access.canWrite && !ReadOnly) &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Delete")}
              style={{ maxWidth: "200px", backgroundColor: "#b30000" }}
              onClick={onClickDelete}
              disabled={loading}
            />
          }
          {(Access.canWrite && !ReadOnly) &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={onClickConfirm}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default ProcessDesignerDetailSetting